enum ReservaUTIEnum {
  ReservaUtiSim = 'ReservaUtiSim',
  ReservaUtiNao = 'ReservaUtiNao',
  SemReserva = 'SemReserva',
  Geral = 'Geral',
  Cardiologia = 'Cardiologia',
  NeoNatal = 'NeoNatal',
  Pediatrica = 'Pediatrica',
  Adulto = 'Adulto',
  Neuro = 'Neuro',
  Cardio = 'Cardio',
  SemiIntensiva = 'SemiIntensiva',
  SemiIntensivaInfantil = 'SemiIntensivaInfantil',
  Neurologica = 'Neurologica',
}

export default ReservaUTIEnum
